import { render, staticRenderFns } from "./project-settings-manage-workflow.vue?vue&type=template&id=069b82e5&"
import script from "./project-settings-manage-workflow.vue?vue&type=script&lang=ts&"
export * from "./project-settings-manage-workflow.vue?vue&type=script&lang=ts&"
import style0 from "./project-settings-manage-workflow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports